import React, { useState, useEffect } from 'react';
import { Modal, Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import { fetchLinkingOrders, linkedOrder } from '../../../redux/orderSlice'; // Import actions from the slice
import MainTable from '../../../components/Table/PaginationTable'; // Your custom MainTable component
import { useSelector, useDispatch } from 'react-redux';
import { LinkedOrderColumnDefShipment } from '../columns/ColumnDefShipment';
import { linkUnlinkBuyerPurchaseOrder } from '../../../redux/shipmentSlice';
import { toast } from 'react-hot-toast';


const LinkedOrdersModalShipment = ({ open, onClose, handleLink, handleUnlink, shipment, orders, shipmentId, currentStep, handleNextStep, totalRecords }) => {
    const dispatch = useDispatch();
    // console.log("SHIP MENT",shipment,"SHIP MENT id is",shipmentId);
    // const isLoading = useSelector(state => state.order.loading);
    const [searchText, setSearchText] = useState('');
    const [pageNumber, setpageNumber] = useState(1); //  1-based indexing
    const [pageSize, setPageSize] = useState(10);
    // const [orderId, setOrderId] = useState(0)
    // const linkedOrderList = useSelector(state => state.order.linkingorders?.data || []);
    const [orderId, setOrderId] = useState('');
    const [orderNumber, setOrderNumber] = useState(shipment?.orderNumber)
    // const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});

    const handleUnlinkOrder = (order) => {
        try {
            // console.log("ORDERRRRRRRR",order);
            if (shipment?.isLinked == 1) {
                const id = orderId || order.orderid;
                dispatch(linkUnlinkBuyerPurchaseOrder({ shipmentId, orderId: id, action: 'unlink' }))
                    .then((response) => {
                        // console.log("RESPONSEEE:",response);
                        toast.success("Order Unlinked Successfully!!");
                    })
            }
            handleUnlink();
            setOrderId('');
            setOrderNumber(null);
            onClose();
        }
        catch {
            console.log("AN error occurred!!");
        }
        // dispatch(unlinkOrder({ orderId }));
    };

    const handleLinkOrder = (selectedOrder) => {

        // const link = handleLink(selectedOrder);
        const link = handleLink(selectedOrder)
        if (link) {
            setOrderId(selectedOrder.orderid)
            setOrderNumber(selectedOrder.ordernumber)
        }
        onClose();
        // console.log("selectedOrderselectedOrder",selectedOrder)
        // console.log("INSIDE handleLinkOrder orderId",orderId);
    }
    const buyerPoList = LinkedOrderColumnDefShipment(handleLinkOrder, handleUnlinkOrder, orderId, orderNumber)

    // Function to handle search input changes
    const handleSearchChange = (event) => {
        setSearchText(event.target.value.toLowerCase());
    };
    // Handle page size change
    const handlePageIndexChange = (newPageIndex) => {
        setpageNumber(newPageIndex);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        console.log("Page size changed to:", newSize);
    };


    // useEffect(() => {

    //     console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
    //     const queryParams = {
    //         searchText: '',
    //         fromDate: '',
    //         toDate: '',
    //         pageSize, // Use state value
    //         pageNumber, // Use state value
    //     };
    //     dispatch(fetchLinkingOrders(queryParams));
    // }, [dispatch, pageSize, pageNumber]);

    // console.log('Count ', ordersToLink, linkedOrderList[0])
    // if (isLoading) {
    //     return <div>Loading...</div>; // Or any other loading indicator
    // }
    // Adjust Box styling to your preference
    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4, overflowY: 'auto' }}>
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
                <TextField
                    fullWidth
                    label="Search Orders"
                    value={searchText}
                    onChange={handleSearchChange}
                    sx={{ mb: 2 }}
                />
                <MainTable
                    columns={buyerPoList}
                    data={orders}
                    enablePagination={true}
                    pageNumber={pageNumber}
                    initialPageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    onPageIndexChange={handlePageIndexChange}
                    totalRecords={totalRecords}
                />
            </Box>
        </Modal>
    );
}

export default LinkedOrdersModalShipment;

